var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "es-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #aa151b } \n\t\t.s1 { fill: #f1bf00 } \n\t\t.s2 { fill: #ad1519 } \n\t\t.s3 { fill: none;stroke: #000000;stroke-linejoin: round;stroke-width: 0 } \n\t\t.s4 { fill: #c8b100 } \n\t\t.s5 { fill: none;stroke: #000000;stroke-width: 0 } \n\t\t.s6 { fill: #ffffff } \n\t\t.s7 { fill: #058e6e } \n\t\t.s8 { fill: #005bbf } \n\t\t.s9 { fill: #cccccc } \n\t\t.s10 { fill: none;stroke: #000000;stroke-linecap: round;stroke-width: 0 } \n\t\t.s11 { fill: #ad1519;stroke: #000000;stroke-width: 0 } \n\t\t.s12 { fill: #c8b100;stroke: #000000;stroke-width: 0 } \n\t\t.s13 { fill: #ffffff;stroke: #000000;stroke-width: 0 } \n\t\t.s14 { fill: #058e6e;stroke: #000000;stroke-width: 0 } \n\t\t.s15 { fill: #005bbf;stroke: #000000;stroke-width: 0 } \n\t\t.s16 { fill: #c8b100;stroke: #000000;stroke-linejoin: round;stroke-width: 0 } \n\t\t.s17 { fill: #c7b500;stroke: #000000;stroke-width: 0 } \n\t\t.s18 { fill: none;stroke: #c8b100;stroke-width: 0 } \n\t\t.s19 { fill: #db4446 } \n\t\t.s20 { fill: #ed72aa;stroke: #000000;stroke-width: 0 } \n\t\t.s21 { fill: #000000 } \n\t\t.s22 { fill: #ffd691;stroke: #000000;stroke-width: 0 } \n\t\t.s23 { fill: #0039f0 } \n\t\t.s24 { fill: none } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m0 0h20v20h-20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m0 5h20v10h-20z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m6.7 8.9q0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0-0.1 0-0.1c0 0 0-0.1 0-0.1q0 0 0-0.1c0 0 0.1 0 0.1 0h0.1 0.1 0.2q0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0.1 0 0.1 0 0 0 0v0.1 0.1q0 0-0.1 0c0 0-0.2 0-0.3 0-0.1 0-0.3 0-0.3 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m6.7 8.9q0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0-0.1 0-0.1c0 0 0-0.1 0-0.1q0 0 0-0.1c0 0 0.1 0 0.1 0h0.1 0.1 0.2q0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0.1 0 0.1 0 0 0 0v0.1 0.1q0 0-0.1 0c0 0-0.2 0-0.3 0-0.1 0-0.3 0-0.3 0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m7 8.7q0 0 0-0.1 0-0.1 0-0.1 0.1 0 0.1 0.1 0 0.1-0.1 0.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7 8.7q0 0 0-0.1 0-0.1 0-0.1 0.1 0 0.1 0.1 0 0.1-0.1 0.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m7 8.7q0 0 0-0.1 0-0.1 0-0.1 0 0 0 0.1 0 0.1 0 0.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7 8.7q0 0 0-0.1 0-0.1 0-0.1 0 0 0 0.1 0 0.1 0 0.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m7 8.5q0 0 0 0 0 0 0.1 0-0.1 0.1-0.1 0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m7 8.5v-0.1h0.1v0.1h-0.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7 8.5v-0.1h0.1v0.1h-0.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m7.1 8.5h-0.1v-0.1h0.1v0.1h-0.1 0.1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7.1 8.5h-0.1v-0.1h0.1v0.1h-0.1 0.1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7 8.5q0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0-0.1 0.1-0.1 0.1 0 0 0-0.1 0 0 0 0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m7 8.9h-0.2v-0.1-0.1q-0.1-0.1-0.1-0.1 0 0 0 0c0 0 0.1 0 0.2 0.1v0.1h0.2v-0.1c0.1-0.1 0.2-0.1 0.2-0.1q0 0 0.1 0-0.1 0-0.2 0.1v0.1 0.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7 8.9h-0.2v-0.1-0.1q-0.1-0.1-0.1-0.1 0 0 0 0c0 0 0.1 0 0.2 0.1v0.1h0.2v-0.1c0.1-0.1 0.2-0.1 0.2-0.1q0 0 0.1 0-0.1 0-0.2 0.1v0.1 0.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m6.9 8.8c-0.1-0.1-0.2-0.2-0.2-0.2m0.6 0c0 0-0.1 0.1-0.1 0.2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m6.7 9q0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0.1 0 0.3 0 0.2 0 0.3 0v0.1q-0.1 0-0.3 0-0.2 0-0.3 0z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m6.7 9q0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0.1 0 0.3 0 0.2 0 0.3 0v0.1q-0.1 0-0.3 0-0.2 0-0.3 0z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m7 9.1q0 0 0.1 0 0 0 0 0 0.1 0 0.1 0 0-0.1 0.1-0.1 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0-0.1 0 0 0 0 0-0.1 0-0.1 0-0.2 0-0.3 0 0 0 0 0 0 0 0.1 0c0 0.1 0.1 0.1 0.2 0.1z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7 9.1q0 0 0.1 0 0 0 0 0 0.1 0 0.1 0 0-0.1 0.1-0.1 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0-0.1 0 0 0 0 0-0.1 0-0.1 0-0.2 0-0.3 0 0 0 0 0 0 0 0.1 0c0 0.1 0.1 0.1 0.2 0.1z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m7.3 8.9q0 0 0 0c-0.1 0-0.1-0.1-0.1-0.1 0 0 0 0.1 0 0.1q-0.1-0.1-0.1-0.1 0 0 0 0.1c-0.1 0-0.1-0.1-0.1-0.1 0 0 0 0.1 0 0.1q-0.1-0.1-0.1-0.1 0 0 0 0.1-0.1 0-0.1-0.1 0 0 0 0.1-0.1 0-0.1 0 0.1 0 0.2 0 0 0 0.1 0 0.1 0 0.2 0 0 0 0.1 0z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7.3 8.9q0 0 0 0c-0.1 0-0.1-0.1-0.1-0.1 0 0 0 0.1 0 0.1q-0.1-0.1-0.1-0.1 0 0 0 0.1c-0.1 0-0.1-0.1-0.1-0.1 0 0 0 0.1 0 0.1q-0.1-0.1-0.1-0.1 0 0 0 0.1-0.1 0-0.1-0.1 0 0 0 0.1-0.1 0-0.1 0 0.1 0 0.2 0 0 0 0.1 0 0.1 0 0.2 0 0 0 0.1 0z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m7 8.8q0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0.1 0.1 0 0 0-0.1 0 0.1 0 0.1 0 0 0.1 0v-0.1q0 0.1 0 0.1h-0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1-0.1 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1-0.1 0 0.1 0 0.1 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0-0.1 0 0.1 0 0.1 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0-0.1l0.1 0.1q0 0 0 0 0 0 0-0.1 0 0.1 0.1 0.1 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7 8.8q0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0.1 0.1 0 0 0-0.1 0 0.1 0 0.1 0 0 0.1 0v-0.1q0 0.1 0 0.1h-0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1-0.1 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1-0.1 0 0.1 0 0.1 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0-0.1 0 0.1 0 0.1 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0-0.1l0.1 0.1q0 0 0 0 0 0 0-0.1 0 0.1 0.1 0.1 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m7 8.9q-0.2 0-0.3 0 0 0 0 0 0.1 0 0.3 0 0.2 0 0.3 0 0 0 0 0-0.1 0-0.3 0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m7 8.9q-0.2 0-0.3 0 0 0 0 0 0.1 0 0.3 0 0.2 0 0.3 0 0 0 0 0-0.1 0-0.3 0z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m6.9 8.9q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m6.9 8.9q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m7 8.9q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0h0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7 8.9q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0h0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m6.8 9q0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0h-0.1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m6.8 9q0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0h-0.1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m6.7 9z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m6.7 9z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m7.1 8.9q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7.1 8.9q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m7.2 9q0 0 0.1-0.1 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7.2 9q0 0 0.1-0.1 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m7.3 9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7.3 9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m7 9q-0.1 0-0.2 0 0 0 0 0 0.1 0 0.1 0 0 0 0.1 0 0 0 0 0 0.2 0 0.3 0-0.1 0-0.3 0z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m7 9q-0.1 0-0.2 0 0 0 0 0 0.1 0 0.1 0 0 0 0.1 0 0 0 0 0 0.2 0 0.3 0-0.1 0-0.3 0z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m7.3 8.8q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7.3 8.8q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m7.1 8.8q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7.1 8.8q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m6.9 8.8q0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m6.9 8.8q0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m6.7 8.8q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m6.7 8.8q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m7 8.7v0.1l0.1-0.1h-0.1"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7 8.7v0.1l0.1-0.1h-0.1"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m6.9 8.8h0.1v-0.1z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m6.9 8.8h0.1v-0.1z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m7.1 8.8h-0.1l0.1-0.1z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7.1 8.8h-0.1l0.1-0.1z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m6.8 8.7v0.1-0.1"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m6.8 8.7v0.1-0.1"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m6.7 8.8h0.1-0.1z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m6.7 8.8h0.1-0.1z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m6.9 8.8h-0.1 0.1z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m6.9 8.8h-0.1 0.1z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m6.7 8.8h-0.1 0.1z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m6.7 8.8h-0.1 0.1z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m6.8 8.8q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m6.8 8.8q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m7.2 8.7h0.1l-0.1 0.1v-0.1"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7.2 8.7h0.1l-0.1 0.1v-0.1"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m7.3 8.8h-0.1 0.1z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7.3 8.8h-0.1 0.1z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m7.1 8.8h0.1z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7.1 8.8h0.1z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m7.3 8.8h0.1z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7.3 8.8h0.1z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m7 8.8q0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7 8.8q0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m7.2 8.8q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7.2 8.8q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m6.6 8.8q0 0 0 0 0 0 0 0"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m6.6 8.8q0 0 0 0 0 0 0 0z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m6.6 8.8q0 0 0 0.1 0 0 0 0 0-0.1 0-0.1"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m6.6 8.8q0 0 0 0.1 0 0 0 0 0-0.1 0-0.1z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m7.4 8.8h0.1q0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7.4 8.8h0.1q0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m7.4 8.8q0 0 0 0.1 0-0.1 0-0.1"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7.4 8.8q0 0 0 0.1 0-0.1 0-0.1z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m6.6 9.1h0.9v0.2h-0.9z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m6.6 9.1h0.9v0.2h-0.9z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m6.7 9.5v-0.1h0.7q-0.1 0-0.1 0 0 0 0.1-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0h-0.6q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m6.7 9.5v-0.1h0.7q-0.1 0-0.1 0 0 0 0.1-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0h-0.6q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m6.7 9.4h0.7q0 0.1 0 0.1 0 0 0 0h-0.7q-0.1 0-0.1 0 0 0 0.1-0.1"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m6.7 9.4h0.7q0 0.1 0 0.1 0 0 0 0h-0.7q-0.1 0-0.1 0 0 0 0.1-0.1z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m6.7 9.3h0.7q0 0 0 0 0 0 0 0h-0.7q-0.1 0-0.1 0 0 0 0.1 0"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m6.7 9.3h0.7q0 0 0 0 0 0 0 0h-0.7q-0.1 0-0.1 0 0 0 0.1 0z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m7.6 13.2q0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0-0.1 0-0.1 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.2 0v0.1q0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0.1 0 0.2 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7.6 13.2q0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0-0.1 0-0.1 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.2 0v0.1q0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0.1 0 0.2 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m7.6 13.3q0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0-0.1 0-0.1 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0-0.1 0-0.1 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0v0.1q0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7.6 13.3q0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0-0.1 0-0.1 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0-0.1 0-0.1 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0v0.1q0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m7.6 13.4q0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0v0.1q0.1 0 0.2 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0-0.1 0-0.1 0 0 0 0.1 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0.1 0 0.1 0 0.1 0 0.1 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0-0.1 0-0.1 0.1 0.1 0.2 0.1 0 0 0.1 0v-0.1"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7.6 13.4q0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0v0.1q0.1 0 0.2 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0-0.1 0-0.1 0 0 0 0.1 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0.1 0 0.1 0 0.1 0 0.1 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0-0.1 0-0.1 0.1 0.1 0.2 0.1 0 0 0.1 0v-0.1"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m7.6 13.6q0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0-0.1 0-0.1-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0.1 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0-0.1-0.1-0.1 0 0 0 0 0 0 0 0-0.1 0.1-0.1 0.1 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0v-0.1q0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0-0.1 0-0.1 0 0 0 0.1 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0.1 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0-0.1 0-0.1 0 0 0.1 0.1 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0.1 0z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7.6 13.6q0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0-0.1 0-0.1-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0.1 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0-0.1-0.1-0.1 0 0 0 0 0 0 0 0-0.1 0.1-0.1 0.1 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0v-0.1q0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0-0.1 0-0.1 0 0 0 0.1 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0.1 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0-0.1 0-0.1 0 0 0.1 0.1 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0.1 0z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m7.6 13.7q0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0-0.1 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0.1 0 0.1 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0-0.1 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0.1 0 0.1 0 0 0 0-0.1 0-0.2 0v-0.1q0.1 0 0.2 0 0 0 0 0 0 0 0 0 0-0.1 0.1-0.1 0 0 0 0 0 0 0 0 0.1 0.1 0.1 0.1 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0.1-0.1 0.1-0.1 0 0 0 0 0 0 0.1 0 0 0 0 0.1 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7.6 13.7q0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0-0.1 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0.1 0 0.1 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0-0.1 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0.1 0 0.1 0 0 0 0-0.1 0-0.2 0v-0.1q0.1 0 0.2 0 0 0 0 0 0 0 0 0 0-0.1 0.1-0.1 0 0 0 0 0 0 0 0 0.1 0.1 0.1 0.1 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0.1-0.1 0.1-0.1 0 0 0 0 0 0 0.1 0 0 0 0 0.1 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m6.7 12.8v0.1q0 0.1-0.1 0.1h0.9q-0.1 0-0.1-0.1v-0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m6.7 12.8v0.1q0 0.1-0.1 0.1h0.9q-0.1 0-0.1-0.1v-0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m6.7 12.8h0.7q0 0 0 0 0 0 0 0h-0.7q-0.1 0-0.1 0 0 0 0.1 0"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m6.7 12.8h0.7q0 0 0 0 0 0 0 0h-0.7q-0.1 0-0.1 0 0 0 0.1 0z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m6.6 13h0.9v0.2h-0.9z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m6.6 13h0.9v0.2h-0.9z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m6.5 11.9q-0.2 0.1-0.2 0.2 0.1 0 0.1 0c0.1 0.1 0.1 0.2 0.1 0.2q0 0 0.1-0.1 0 0 0-0.1 0 0 0-0.1-0.1 0-0.1-0.1"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m6.5 11.9q-0.2 0.1-0.2 0.2 0.1 0 0.1 0c0.1 0.1 0.1 0.2 0.1 0.2q0 0 0.1-0.1 0 0 0-0.1 0 0 0-0.1-0.1 0-0.1-0.1z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m6.7 9.5h0.6v3.2h-0.6z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m6.7 9.6h0.6v3.1h-0.6zm0.5 0v3.2m0-3.2v3.2"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m8 10.7q-0.1 0-0.2 0 0 0-0.1 0-0.1-0.1-0.2-0.1-0.1 0-0.2 0 0 0 0 0-0.1 0-0.1 0-0.1 0-0.1 0 0 0-0.1 0.1c-0.4 0-0.7 0.2-0.6 0.3l-0.2-0.3c0-0.2 0.3-0.3 0.8-0.4q0 0 0.1 0 0 0 0.1 0 0 0 0 0 0.1 0 0.1 0c0.3 0 0.6 0 0.7 0v0.4"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m8 10.7q-0.1 0-0.2 0 0 0-0.1 0-0.1-0.1-0.2-0.1-0.1 0-0.2 0 0 0 0 0-0.1 0-0.1 0-0.1 0-0.1 0 0 0-0.1 0.1c-0.4 0-0.7 0.2-0.6 0.3l-0.2-0.3c0-0.2 0.3-0.3 0.8-0.4q0 0 0.1 0 0 0 0.1 0 0 0 0 0 0.1 0 0.1 0c0.3 0 0.6 0 0.7 0v0.4"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m6.7 11.1q-0.3 0-0.3-0.1 0-0.1 0.1-0.2 0.1 0 0.2 0v0.3"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m6.7 11.1q-0.3 0-0.3-0.1 0-0.1 0.1-0.2 0.1 0 0.2 0v0.3"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m7.3 10.9q0.2 0 0.3 0.1c0 0-0.1 0.1-0.3 0.2v-0.3"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7.3 10.9q0.2 0 0.3 0.1c0 0-0.1 0.1-0.3 0.2v-0.3"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m6.3 11.8c0-0.1 0.1-0.2 0.4-0.3q0.2 0 0.3-0.1c0.4-0.2 0.6-0.4 0.6-0.4 0 0 0 0.3 0 0.3 0.1 0.1-0.2 0.2-0.5 0.4-0.1 0-0.3 0.1-0.4 0.2-0.2 0-0.4 0.1-0.4 0.2z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m6.3 11.8c0-0.1 0.1-0.2 0.4-0.3q0.2 0 0.3-0.1c0.4-0.2 0.6-0.4 0.6-0.4 0 0 0 0.3 0 0.3 0.1 0.1-0.2 0.2-0.5 0.4-0.1 0-0.3 0.1-0.4 0.2-0.2 0-0.4 0.1-0.4 0.2z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s4",
    d: "m6.6 10.6l0.1 0.1h-0.1l-0.1-0.2 0.1-0.1q0.1 0 0.1 0.1 0.1 0-0.1 0.1zm0 0q0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0-0.1 0-0.1 0-0.1-0.1 0zm0.3 0h0.1-0.2v-0.2h0.1zm0.2 0l-0.1-0.3h0.1q0 0.1 0 0.2 0.1 0 0.1-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0l-0.1 0.3zm0.3-0.2q0-0.1 0-0.1-0.1 0-0.1 0.1c0 0 0.2 0 0.2 0.1q-0.1 0.1-0.2 0.1 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0.1 0 0.1-0.1c0 0-0.1 0-0.1-0.1q0-0.1 0.1-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0l-0.1 0.1z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m13 8.8c0 0 0 0-0.1 0.1q0-0.1 0-0.1 0 0-0.1 0.1c0 0 0-0.1 0-0.1q0 0-0.1 0.1 0 0 0 0 0 0 0 0h-0.1v-0.1q0-0.1 0.1-0.1 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0.1 0 0.1 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0.1l-0.1 0.1q0 0 0 0 0 0 0 0 0 0-0.1 0 0-0.1 0-0.1c0 0-0.1 0.1-0.1 0.1q0-0.1 0-0.1 0 0-0.1 0.1c0 0 0-0.1 0-0.1"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m13 8.8c0 0 0 0-0.1 0.1q0-0.1 0-0.1 0 0-0.1 0.1c0 0 0-0.1 0-0.1q0 0-0.1 0.1 0 0 0 0 0 0 0 0h-0.1v-0.1q0-0.1 0.1-0.1 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0.1 0 0.1 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0.1l-0.1 0.1q0 0 0 0 0 0 0 0 0 0-0.1 0 0-0.1 0-0.1c0 0-0.1 0.1-0.1 0.1q0-0.1 0-0.1 0 0-0.1 0.1c0 0 0-0.1 0-0.1z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m12.9 8.6q0 0 0.1 0 0 0 0 0 0 0.1 0 0.1-0.1 0-0.1-0.1"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.9 8.6q0 0 0.1 0 0 0 0 0 0 0.1 0 0.1-0.1 0-0.1-0.1z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m13 8.7q0 0 0-0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m13 8.7q0 0 0-0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m12.7 9q0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0.1 0 0.3 0 0.2 0 0.3 0v0.1q-0.2 0-0.3 0-0.2 0-0.3 0"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.7 9q0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0.1 0 0.3 0 0.2 0 0.3 0v0.1q-0.2 0-0.3 0-0.2 0-0.3 0"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m13 9.1c0.1 0 0.2 0 0.2-0.1q0.1 0 0.1 0 0 0 0 0-0.1 0-0.1 0 0 0-0.1 0 0 0-0.1 0 0 0 0 0-0.1 0-0.1 0 0 0-0.1 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0c0.1 0.1 0.2 0.1 0.3 0.1z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m13 9.1c0.1 0 0.2 0 0.2-0.1q0.1 0 0.1 0 0 0 0 0-0.1 0-0.1 0 0 0-0.1 0 0 0-0.1 0 0 0 0 0-0.1 0-0.1 0 0 0-0.1 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0c0.1 0.1 0.2 0.1 0.3 0.1z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m13.2 8.7q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m13.2 8.7q0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0zm0-0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0zm0 0q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0zm-0.1 0q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0zm-0.1 0q0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0-0.1 0.1 0 0 0 0z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s10",
    d: "m13.4 8.8q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0-0.1-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1-0.1 0-0.1 0"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m13.2 8.7q0-0.1-0.1-0.1 0 0-0.1 0"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m13.4 8.7q0 0 0 0 0 0 0 0.1zm0-0.1q0 0 0 0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1zm0 0q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0zm0-0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0zm-0.1 0q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0zm0 0q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m13.3 8.9q0 0-0.1 0c0 0 0-0.1 0-0.1 0 0 0 0.1-0.1 0.1q0-0.1 0-0.1 0 0-0.1 0.1c0 0 0-0.1 0-0.1 0 0 0 0.1-0.1 0.1q0-0.1 0-0.1 0 0-0.1 0.1 0 0 0-0.1 0 0-0.1 0.1 0 0 0 0 0.1 0 0.1 0 0.1 0 0.2 0 0.1 0 0.1 0 0.1 0 0.2 0z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m13.3 8.9q0 0-0.1 0c0 0 0-0.1 0-0.1 0 0 0 0.1-0.1 0.1q0-0.1 0-0.1 0 0-0.1 0.1c0 0 0-0.1 0-0.1 0 0 0 0.1-0.1 0.1q0-0.1 0-0.1 0 0-0.1 0.1 0 0 0-0.1 0 0-0.1 0.1 0 0 0 0 0.1 0 0.1 0 0.1 0 0.2 0 0.1 0 0.1 0 0.1 0 0.2 0z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m12.7 8.7q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.7 8.7q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0zm0-0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0zm0.1 0q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0zm0 0q0 0 0 0 0.1 0 0.1 0 0 0-0.1 0 0 0 0 0zm0.1 0q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s10",
    d: "m12.6 8.8q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0.1 0 0 0 0 0.1"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.8 8.7q0-0.1 0.1-0.1 0 0 0 0"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.5 8.7q0 0 0 0 0 0 0 0.1zm0-0.1q0 0 0.1 0.1 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1zm0 0q0 0 0 0 0.1 0 0.1 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0zm0.1-0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0zm0 0q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0zm0.1 0q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m13 8.8q0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0-0.1 0-0.1 0 0.1 0 0.1 0 0 0 0l0.1-0.1q0 0.1-0.1 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0-0.1 0 0.1 0 0.1 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0.1-0.1 0.1 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0.1-0.1 0-0.1 0 0 0 0 0 0 0 0-0.1 0 0.1 0 0.1 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0v-0.1 0.1q0.1 0 0.1 0 0 0 0-0.1 0 0.1 0 0.1 0.1 0 0.1-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m13 8.8q0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0-0.1 0-0.1 0 0.1 0 0.1 0 0 0 0l0.1-0.1q0 0.1-0.1 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0-0.1 0 0.1 0 0.1 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0.1-0.1 0.1 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0.1-0.1 0-0.1 0 0 0 0 0 0 0 0-0.1 0 0.1 0 0.1 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0v-0.1 0.1q0.1 0 0.1 0 0 0 0-0.1 0 0.1 0 0.1 0.1 0 0.1-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m13 8.9q-0.2 0-0.3 0 0.1 0 0.3 0 0.2 0 0.3 0 0 0 0 0 0 0 0 0-0.1 0-0.3 0"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m13 8.9q-0.2 0-0.3 0 0.1 0 0.3 0 0.2 0 0.3 0 0 0 0 0 0 0 0 0-0.1 0-0.3 0z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m12.9 8.9q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.9 8.9q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m13 8.9h-0.1q0 0 0 0 0 0 0 0h0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m13 8.9h-0.1q0 0 0 0 0 0 0 0h0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m12.8 9q0 0 0 0 0 0 0 0-0.1 0-0.1-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.8 9q0 0 0 0 0 0 0 0-0.1 0-0.1-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m12.7 9z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.7 9z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m13.1 8.9q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m13.1 8.9q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m13.2 9q0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0h0.1"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m13.2 9q0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0h0.1"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m13.3 9h-0.1 0.1"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m13.3 9h-0.1 0.1"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m13 9q-0.1 0-0.1 0 0 0 0 0-0.1 0-0.1 0 0 0-0.1 0 0.1 0 0.2 0 0 0 0.1 0 0 0 0.1 0 0.1 0 0.1 0 0 0 0 0-0.1 0-0.1 0 0 0-0.1 0 0 0 0 0z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m13 9q-0.1 0-0.1 0 0 0 0 0-0.1 0-0.1 0 0 0-0.1 0 0.1 0 0.2 0 0 0 0.1 0 0 0 0.1 0 0.1 0 0.1 0 0 0 0 0-0.1 0-0.1 0 0 0-0.1 0 0 0 0 0z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m13.3 8.8q0 0 0 0 0 0 0 0z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m13.3 8.8q0 0 0 0 0 0 0 0z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m13.1 8.8q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m13.1 8.8q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m12.9 8.8q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.9 8.8q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m12.7 8.8q0 0 0 0 0 0 0 0z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.7 8.8q0 0 0 0 0 0 0 0z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m13 8.7h-0.1l0.1 0.1v-0.1z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m13 8.7h-0.1l0.1 0.1v-0.1z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m12.9 8.8h0.1l-0.1-0.1z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.9 8.8h0.1l-0.1-0.1z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m13.1 8.8h-0.1v-0.1z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m13.1 8.8h-0.1v-0.1z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m12.8 8.7h-0.1l0.1 0.1v-0.1z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.8 8.7h-0.1l0.1 0.1v-0.1z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m12.7 8.8h0.1-0.1z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.7 8.8h0.1-0.1z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m12.9 8.8h-0.1z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.9 8.8h-0.1z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m12.6 8.8z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.6 8.8z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m12.8 8.8q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.8 8.8q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m13.2 8.7v0.1-0.1"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m13.2 8.7v0.1-0.1"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m13.3 8.8h-0.1 0.1z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m13.3 8.8h-0.1 0.1z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m13.1 8.8h0.1-0.1z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m13.1 8.8h0.1-0.1z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m13.3 8.8h0.1-0.1z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m13.3 8.8h0.1-0.1z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m13 8.8q0 0 0-0.1 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m13 8.8q0 0 0-0.1 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m13.2 8.8q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m13.2 8.8q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m12.9 8.6q0-0.1 0.1-0.1 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m13 8.5v0.1h-0.1v-0.1h0.1-0.1 0.1v-0.1 0.1z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m13 8.5v0.1h-0.1v-0.1h0.1-0.1 0.1v-0.1 0.1z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m13 8.5v0.1h-0.1v-0.1h0.1-0.1 0.1v-0.1 0.1"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m13 8.5q0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0-0.1 0.1-0.1"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m12.6 8.8h-0.1q0 0 0 0h0.1q0 0 0 0 0 0 0 0z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.6 8.8h-0.1q0 0 0 0h0.1q0 0 0 0 0 0 0 0z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m12.6 8.8q0 0 0 0.1 0-0.1 0-0.1"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.6 8.8q0 0 0 0.1 0-0.1 0-0.1z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m13.4 8.8q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m13.4 8.8q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m13.4 8.8q0 0 0 0.1 0 0 0 0 0-0.1 0-0.1"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m13.4 8.8q0 0 0 0.1 0 0 0 0 0-0.1 0-0.1z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m12.5 9.3h0.9v-0.2h-0.9v0.2z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.5 9.3h0.9v-0.2h-0.9v0.2z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m13.3 9.5q0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0h-0.7q0.1 0 0.1 0 0 0-0.1-0.1h0.7q0 0.1 0 0.1 0 0 0 0"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m13.3 9.5q0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0h-0.7q0.1 0 0.1 0 0 0-0.1-0.1h0.7q0 0.1 0 0.1 0 0 0 0z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m12.7 9.4h0.6q0.1 0.1 0.1 0.1 0 0-0.1 0h-0.6q-0.1 0-0.1 0 0 0 0.1-0.1z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.7 9.4h0.6q0.1 0.1 0.1 0.1 0 0-0.1 0h-0.6q-0.1 0-0.1 0 0 0 0.1-0.1z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m12.7 9.3h0.6q0.1 0 0.1 0 0 0-0.1 0h-0.6q-0.1 0-0.1 0 0 0 0 0"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.7 9.3h0.6q0.1 0 0.1 0 0 0-0.1 0h-0.6q-0.1 0-0.1 0 0 0 0 0z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m12.4 13.2q0.1 0 0.1 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0.1 0 0.1 0 0.1 0 0.2 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0.1 0 0.1 0 0.1 0 0.2 0v0.1q0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0-0.1 0-0.2 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0-0.1 0-0.2 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.4 13.2q0.1 0 0.1 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0.1 0 0.1 0 0.1 0 0.2 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0.1 0 0.1 0 0.1 0 0.2 0v0.1q0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0-0.1 0-0.2 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0-0.1 0-0.2 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m12.4 13.3q0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0.1 0 0.1 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0.1 0 0.1 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0v0.1q0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0-0.1 0-0.2 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.4 13.3q0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0.1 0 0.1 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0.1 0 0.1 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0v0.1q0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0-0.1 0-0.2 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m12.4 13.4q0.1 0 0.1 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.2 0 0.1 0 0.1 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0.1 0 0.1 0 0.1 0 0.2 0v0.1q0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0-0.1 0-0.1 0 0 0 0.1-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0-0.1 0-0.1-0.1 0.1-0.2 0.1 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0v-0.1"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.4 13.4q0.1 0 0.1 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.2 0 0.1 0 0.1 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0.1 0 0.1 0 0.1 0 0.2 0v0.1q0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0-0.1 0-0.1 0 0 0 0.1-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0-0.1 0-0.1-0.1 0.1-0.2 0.1 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0v-0.1"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m12.4 13.6q0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0-0.1 0-0.1 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0.1 0 0 0 0 0 0 0 0 0.1 0 0.2 0 0.1 0 0.1 0 0.1 0 0.1 0 0 0 0 0 0-0.1 0.1-0.1 0 0 0 0 0.1 0 0.1 0.1 0.1 0 0.2 0v-0.1q0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0-0.1 0-0.1 0 0 0 0.1-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0-0.1 0-0.1 0 0-0.1 0.1 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.4 13.6q0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0-0.1 0-0.1 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0.1 0 0 0 0 0 0 0 0 0.1 0 0.2 0 0.1 0 0.1 0 0.1 0 0.1 0 0 0 0 0 0-0.1 0.1-0.1 0 0 0 0 0.1 0 0.1 0.1 0.1 0 0.2 0v-0.1q0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0-0.1 0-0.1 0 0 0 0.1-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0-0.1 0-0.1 0 0-0.1 0.1 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m12.4 13.7q0.1 0 0.1 0 0 0 0.1 0 0 0 0-0.1 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0.1 0 0.1 0 0 0 0 0.1 0 0.2 0 0.1 0 0.1 0 0.1 0 0.1 0 0 0 0-0.1 0 0 0.1 0 0 0 0 0 0.1 0 0.1 0.1 0.1 0 0.2 0v-0.1q0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0-0.1-0.1-0.1 0 0 0 0-0.1 0-0.2 0.1 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0-0.1-0.1-0.1-0.1 0 0 0 0 0 0-0.1 0 0 0 0 0.1 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.4 13.7q0.1 0 0.1 0 0 0 0.1 0 0 0 0-0.1 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0.1 0 0.1 0 0 0 0 0.1 0 0.2 0 0.1 0 0.1 0 0.1 0 0.1 0 0 0 0-0.1 0 0 0.1 0 0 0 0 0 0.1 0 0.1 0.1 0.1 0 0.2 0v-0.1q0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0-0.1-0.1-0.1 0 0 0 0-0.1 0-0.2 0.1 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0-0.1-0.1-0.1-0.1 0 0 0 0 0 0-0.1 0 0 0 0 0.1 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m13.3 12.8v0.1q0 0.1 0.1 0.1h-0.9q0.1 0 0.1-0.1 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m13.3 12.8v0.1q0 0.1 0.1 0.1h-0.9q0.1 0 0.1-0.1 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m12.7 12.8h0.6q0.1 0 0.1 0 0 0-0.1 0h-0.6q-0.1 0-0.1 0 0 0 0.1 0"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.7 12.8h0.6q0.1 0 0.1 0 0 0-0.1 0h-0.6q-0.1 0-0.1 0 0 0 0.1 0z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m12.5 13.2h0.9v-0.2h-0.9v0.2z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.5 13.2h0.9v-0.2h-0.9v0.2z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m13.5 11.9q0.2 0.1 0.2 0.2-0.1 0-0.1 0c-0.1 0.1-0.1 0.2-0.1 0.2q0 0-0.1-0.1 0 0 0-0.1 0 0 0-0.1 0.1 0 0.1-0.1"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m13.5 11.9q0.2 0.1 0.2 0.2-0.1 0-0.1 0c-0.1 0.1-0.1 0.2-0.1 0.2q0 0-0.1-0.1 0 0 0-0.1 0 0 0-0.1 0.1 0 0.1-0.1z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m12.7 12.7h0.6v-3.2h-0.6v3.2z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.7 12.7h0.6v-3.2h-0.6v3.2zm0.5-3.2v3.2m-0.1-3.2v3.2"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m12 10.7q0.1 0 0.2 0 0.2 0 0.3-0.1 0.1 0 0.2 0 0.1 0 0.3 0.1c0.4 0 0.7 0.2 0.6 0.3 0 0 0.2-0.3 0.2-0.3 0-0.2-0.3-0.3-0.8-0.4q0 0-0.1 0 0 0-0.1 0 0 0 0 0-0.1 0-0.1 0c-0.3 0-0.6 0-0.7 0v0.4"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m12 10.7q0.1 0 0.2 0 0.2 0 0.3-0.1 0.1 0 0.2 0 0.1 0 0.3 0.1c0.4 0 0.7 0.2 0.6 0.3 0 0 0.2-0.3 0.2-0.3 0-0.2-0.3-0.3-0.8-0.4q0 0-0.1 0 0 0-0.1 0 0 0 0 0-0.1 0-0.1 0c-0.3 0-0.6 0-0.7 0v0.4"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m13.3 11.1q0.3 0 0.3-0.1 0-0.1-0.1-0.2-0.1 0-0.2 0v0.3"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m13.3 11.1q0.3 0 0.3-0.1 0-0.1-0.1-0.2-0.1 0-0.2 0v0.3"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m12.7 10.9q-0.2 0-0.3 0.1c0 0 0.1 0.1 0.3 0.2v-0.3"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.7 10.9q-0.2 0-0.3 0.1c0 0 0.1 0.1 0.3 0.2v-0.3"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m13.7 11.8c0-0.1-0.1-0.2-0.4-0.3q-0.2 0-0.3-0.1c-0.4-0.2-0.6-0.4-0.6-0.4 0 0 0 0.3 0 0.3-0.1 0.1 0.2 0.2 0.5 0.4 0.1 0 0.3 0.1 0.4 0.2 0.2 0 0.4 0.1 0.4 0.2z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m13.7 11.8c0-0.1-0.1-0.2-0.4-0.3q-0.2 0-0.3-0.1c-0.4-0.2-0.6-0.4-0.6-0.4 0 0 0 0.3 0 0.3-0.1 0.1 0.2 0.2 0.5 0.4 0.1 0 0.3 0.1 0.4 0.2 0.2 0 0.4 0.1 0.4 0.2z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s4",
    d: "m12.4 10.6q-0.1 0-0.1-0.1 0 0 0 0 0 0-0.1-0.1 0 0 0 0h0.1l0.1 0.1q0-0.1 0-0.2 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0.2-0.1 0.3m0.2-0.3zm0 0v0.3q0.1 0 0.1 0 0 0 0-0.1 0 0 0 0 0 0 0 0v0.1h-0.1v-0.3zm0.2 0.3v-0.2h-0.1v-0.1h0.2v0.1zm0.1-0.3l0.1 0.1q0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1v0.1q0 0-0.1 0v-0.1 0.1h-0.1q0 0 0 0zm0 0.1q0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1-0.1-0.1zm0.3 0.2h-0.1l0.3-0.2q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0v0.3h-0.1v-0.1zm0.1 0v-0.1l-0.1 0.1z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m9 8q0-0.1 0.1-0.1 0.1 0 0.1 0.1 0 0.1-0.1 0.1 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0-0.1 0-0.1z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m10 7.3c0.2 0 0.5 0 0.6 0.1q0.1 0 0.1 0 0.1 0.1 0.1 0.1 0 0 0.1 0 0 0 0.1 0 0.1 0 0.2 0 0.2 0 0.5 0.1 0 0 0.1 0 0 0.1 0 0.1 0.1 0 0.1 0 0 0.1 0.1 0.1l-0.1 0.1v0.1l-0.2 0.2-0.1 0.1-0.2 0.1-0.1 0.1-1.3-0.1-1.3 0.1h-0.1l-0.1-0.1-0.2-0.1-0.1-0.1-0.1-0.2-0.1-0.1v-0.1q0 0 0.1-0.1 0 0 0 0 0.1 0 0.1-0.1 0.1 0 0.1 0 0.2-0.1 0.4-0.1 0.1 0 0.3 0 0 0 0.1 0 0 0 0.1 0 0 0 0.1-0.1 0 0 0 0 0.3-0.1 0.7-0.1z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m10 9c-0.5 0-0.9 0-1.3-0.1q0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0.3-0.1 0.1 0 0.3 0 0.1 0 0.3-0.1 0.1 0 0.3 0c0.5 0 0.9 0.1 1.2 0.2q0.1 0 0.1 0 0 0.1-0.1 0.1-0.1 0-0.3 0.1-0.1 0-0.3 0-0.1 0-0.3 0-0.1 0.1-0.3 0.1"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m10 9q-0.2 0-0.3 0-0.1 0-0.3 0-0.1-0.1-0.3-0.1-0.1 0-0.3 0 0.5-0.2 1.2-0.2 0.1 0 0.3 0 0.1 0 0.3 0.1 0.1 0 0.3 0 0.1 0 0.2 0.1-0.4 0.1-1.1 0.1z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m10 9v-0.3m0 0.3v-0.3"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m9.9 9v-0.3m-0.1 0.3v-0.3"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m9.8 9v-0.3m-0.2 0.3v-0.3m0.1 0.3v-0.3"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m9.5 9v-0.3m0.1 0.3v-0.3m-0.2 0.2v-0.1m0 0.1v-0.2m0.1 0.3v-0.3"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m9.4 8.9v-0.1m-0.1 0.1v-0.1"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m9.3 8.9v-0.1m-0.1 0.1v-0.1m0 0.1v-0.1"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m9.1 8.9v-0.1m0 0.1v-0.1"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m9 8.9v-0.1m0 0.1v-0.1"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m8.9 8.9v-0.1"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m10.3 9v-0.3m-0.1 0.3v-0.3m-0.1 0.3v-0.3"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m10 8.6q-0.2 0-0.3 0.1-0.2 0-0.3 0-0.2 0-0.4 0-0.1 0.1-0.3 0.1 0.1 0 0-0.1c0-0.1-0.1-0.1-0.1-0.1q0.2-0.1 0.4-0.1 0.1 0 0.3-0.1 0.2 0 0.3 0 0.2 0 0.4 0c0.5 0 1 0.1 1.4 0.2 0 0-0.1 0-0.1 0.1q-0.1 0.1 0 0.1c-0.4-0.1-0.8-0.2-1.3-0.2z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m10 8.4q-0.2 0-0.4 0-0.1 0-0.3 0-0.2 0.1-0.3 0.1-0.2 0-0.4 0.1 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0c0.3-0.1 0.8-0.2 1.4-0.2 0.5 0 1 0.1 1.4 0.2q0 0 0 0.1 0 0 0 0c-0.4-0.1-0.9-0.2-1.4-0.2"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m10 9q-0.2 0-0.3 0-0.1 0-0.3 0-0.1-0.1-0.3-0.1-0.1 0-0.3 0 0.5-0.2 1.2-0.2 0.1 0 0.3 0 0.1 0 0.3 0.1 0.1 0 0.3 0 0.1 0 0.2 0.1-0.4 0.1-1.1 0.1z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m9.6 8.5q0 0 0.1 0 0 0 0 0 0 0.1 0 0.1-0.1 0-0.1 0 0 0 0 0 0 0 0-0.1 0 0 0 0"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m10 8.6h-0.1q-0.1 0-0.1-0.1 0 0 0.1 0h0.2q0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0.1-0.1 0.1z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s14",
    d: "m9.3 8.6h-0.1q0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0h0.1 0.1q0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0.1-0.1 0.1h-0.1"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m8.9 8.6q0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m8.7 8.7v-0.1h0.1l-0.1 0.1z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s14",
    d: "m10.7 8.6h0.1q0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0h-0.1-0.1q-0.1 0-0.1 0 0 0.1 0.1 0.1z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m10.3 8.5q0 0 0 0 0.1 0 0.1 0 0 0.1-0.1 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1zm0.7 0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m11.3 8.7v-0.1h-0.2l0.2 0.1"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m8.8 8.9q0.5-0.2 1.2-0.2c0.5 0 0.9 0.1 1.2 0.2"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m9 7.7h0.1v-0.1q0-0.1 0-0.1-0.1 0-0.1-0.1 0 0 0 0 0-0.1 0-0.1c0-0.2 0.2-0.3 0.5-0.3q0.2 0 0.3 0.1v-0.1q0 0 0-0.1-0.1 0-0.1 0-0.1 0-0.1 0-0.1 0-0.1 0c-0.3 0-0.6 0.2-0.6 0.4q0 0 0 0.1 0 0 0 0 0.1 0.1 0.1 0.1 0 0.1 0 0.1v0.1"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m9 7.7h0.1v-0.1q0-0.1 0-0.1-0.1 0-0.1-0.1 0 0 0 0 0-0.1 0-0.1c0-0.2 0.2-0.3 0.5-0.3q0.2 0 0.3 0.1v-0.1q0 0 0-0.1-0.1 0-0.1 0-0.1 0-0.1 0-0.1 0-0.1 0c-0.3 0-0.6 0.2-0.6 0.4q0 0 0 0.1 0 0 0 0 0.1 0.1 0.1 0.1 0 0.1 0 0.1v0.1"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m9 7.7q0-0.1-0.1-0.1 0 0 0-0.1 0 0 0-0.1-0.1 0-0.1 0 0-0.3 0.3-0.4-0.1 0-0.1 0.1 0 0 0 0-0.1 0.1-0.1 0.1 0 0 0 0.1 0 0 0 0.1 0 0 0 0 0.1 0.1 0.1 0.1 0 0.1 0 0.1v0.1"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m9 7.7q0-0.1-0.1-0.1 0 0 0-0.1 0 0 0-0.1-0.1 0-0.1 0 0-0.3 0.3-0.4-0.1 0-0.1 0.1 0 0 0 0-0.1 0.1-0.1 0.1 0 0 0 0.1 0 0 0 0.1 0 0 0 0 0.1 0.1 0.1 0.1 0 0.1 0 0.1v0.1"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m8.1 7.8q0 0-0.1-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0-0.1 0-0.2c0.1-0.2 0.4-0.3 0.7-0.3q0.1 0 0.2 0 0 0 0 0.1 0 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0c-0.3 0-0.5 0.1-0.6 0.2q0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0.1 0.1 0.1l-0.1 0.2-0.1-0.1 0.1-0.1"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m8.1 7.8q0 0-0.1-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0-0.1 0-0.2c0.1-0.2 0.4-0.3 0.7-0.3q0.1 0 0.2 0 0 0 0 0.1 0 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0c-0.3 0-0.5 0.1-0.6 0.2q0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0.1 0.1 0.1l-0.1 0.2-0.1-0.1 0.1-0.1z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m8.2 7.2q0 0-0.1 0.1 0 0 0 0 0 0 0 0-0.1 0.1-0.1 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0.1 0 0.1 0.1 0.2l-0.1 0.1q0 0 0-0.1 0 0-0.1 0 0-0.1 0-0.1 0 0 0-0.1 0-0.2 0.3-0.4z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m8.2 7.2q0 0-0.1 0.1 0 0 0 0 0 0 0 0-0.1 0.1-0.1 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0.1 0 0.1 0.1 0.2l-0.1 0.1q0 0 0-0.1 0 0-0.1 0 0-0.1 0-0.1 0 0 0-0.1 0-0.2 0.3-0.4z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m10 6.9q0.1 0 0.1 0.1 0.1 0 0.1 0.1v0.1q0 0.2 0 0.3l-0.2 0.2-0.2-0.2q0-0.1 0-0.3v-0.1q0-0.1 0-0.1 0.1-0.1 0.2-0.1"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m10 6.9q0.1 0 0.1 0.1 0.1 0 0.1 0.1v0.1q0 0.2 0 0.3l-0.2 0.2-0.2-0.2q0-0.1 0-0.3v-0.1q0-0.1 0-0.1 0.1-0.1 0.2-0.1z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m10 6.9q0 0 0 0 0 0 0 0 0 0 0.1 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0v0.1q0 0.2 0 0.3l-0.1 0.1-0.2-0.1q0.1-0.1 0.1-0.3v-0.1q0 0 0-0.1 0-0.1 0.1-0.1"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m10 6.9q0 0 0 0 0 0 0 0 0 0 0.1 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0v0.1q0 0.2 0 0.3l-0.1 0.1-0.2-0.1q0.1-0.1 0.1-0.3v-0.1q0 0 0-0.1 0-0.1 0.1-0.1z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m11 7.7h-0.1l-0.1-0.1q0.1-0.1 0.1-0.1 0 0 0.1-0.1 0 0 0 0 0-0.1 0-0.1c0-0.2-0.2-0.3-0.5-0.3q0 0-0.1 0 0 0-0.1 0 0 0-0.1 0 0 0-0.1 0.1 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1-0.1 0.1 0 0.1 0 0.1 0 0.1 0 0.1 0 0.1 0c0.3 0 0.5 0.2 0.6 0.4q0 0 0 0.1 0 0-0.1 0 0 0.1 0 0.1 0 0.1-0.1 0.1z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11 7.7h-0.1l-0.1-0.1q0.1-0.1 0.1-0.1 0 0 0.1-0.1 0 0 0 0 0-0.1 0-0.1c0-0.2-0.2-0.3-0.5-0.3q0 0-0.1 0 0 0-0.1 0 0 0-0.1 0 0 0-0.1 0.1 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1-0.1 0.1 0 0.1 0 0.1 0 0.1 0 0.1 0 0.1 0c0.3 0 0.5 0.2 0.6 0.4q0 0 0 0.1 0 0-0.1 0 0 0.1 0 0.1 0 0.1-0.1 0.1z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m11 7.7q0.1-0.2 0.1-0.3 0-0.3-0.2-0.4 0.1 0 0.1 0.1 0 0 0 0 0 0.1 0.1 0.1 0 0.1 0 0.1 0 0.2-0.2 0.3l0.1 0.1"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11 7.7q0.1-0.2 0.1-0.3 0-0.3-0.2-0.4 0.1 0 0.1 0.1 0 0 0 0 0 0.1 0.1 0.1 0 0.1 0 0.1 0 0.2-0.2 0.3l0.1 0.1"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m11.9 7.8q0 0 0.1-0.1 0 0 0-0.1 0 0 0-0.1 0-0.1 0-0.1c-0.1-0.2-0.4-0.3-0.7-0.3q0 0-0.1 0 0 0 0 0-0.1 0-0.1 0 0 0-0.1 0 0.1 0 0.1 0.1 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0.1 0 0.1 0c0.3 0 0.5 0.1 0.6 0.2q0 0.1 0 0.2 0 0 0 0 0 0.1 0 0.1 0 0 0 0-0.1 0.1-0.1 0.1l0.1 0.2 0.1-0.1-0.1-0.1"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.9 7.8q0 0 0.1-0.1 0 0 0-0.1 0 0 0-0.1 0-0.1 0-0.1c-0.1-0.2-0.4-0.3-0.7-0.3q0 0-0.1 0 0 0 0 0-0.1 0-0.1 0 0 0-0.1 0 0.1 0 0.1 0.1 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0.1 0 0.1 0c0.3 0 0.5 0.1 0.6 0.2q0 0.1 0 0.2 0 0 0 0 0 0.1 0 0.1 0 0 0 0-0.1 0.1-0.1 0.1l0.1 0.2 0.1-0.1-0.1-0.1z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m11.8 7.2q0 0 0 0.1 0.1 0 0.1 0 0 0 0 0 0 0.1 0.1 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0.1 0 0.1-0.1 0.2l0.1 0.1q0 0 0-0.1 0 0 0 0 0-0.1 0.1-0.1 0 0 0-0.1 0-0.2-0.3-0.4"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.8 7.2q0 0 0 0.1 0.1 0 0.1 0 0 0 0 0 0 0.1 0.1 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0.1 0 0.1-0.1 0.2l0.1 0.1q0 0 0-0.1 0 0 0 0 0-0.1 0.1-0.1 0 0 0-0.1 0-0.2-0.3-0.4z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m9.9 7.6q0-0.1 0.1-0.1 0.1 0 0.1 0.1 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m9.9 7.6q0-0.1 0.1-0.1 0.1 0 0.1 0.1 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m9.9 7.4q0 0 0 0 0 0 0 0 0 0 0.1-0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0.1-0.1 0.1 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0-0.1 0 0 0 0m0-0.1q0-0.1 0.1-0.1 0 0 0.1 0.1-0.1 0-0.1 0-0.1 0-0.1 0m0-0.2q0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0-0.1-0.1 0-0.1 0m0.1-0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m10 8q0 0 0 0.1 0.1 0 0.1 0.1 0 0 0 0 0.1 0 0.1 0 0.1 0.1 0.1 0 0 0 0 0 0.1 0 0.1 0 0-0.1 0-0.1c0 0 0 0 0 0 0.1 0 0.1 0 0.1 0 0 0.1 0.1 0.2 0.2 0.2q0 0 0 0 0.1 0 0.1-0.1 0 0 0 0 0.1-0.1 0-0.1l0.1-0.1v0.1q0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0.1 0.1 0.1 0.1 0 0 0 0 0.1 0.1 0.1 0.1 0 0 0.1-0.1 0 0 0 0 0 0 0 0 0.1 0 0.1 0v-0.1 0.1q0 0.1 0.1 0.1c0 0 0.1 0 0.2-0.1q0 0 0 0 0 0 0 0 0 0 0.1-0.1 0 0 0 0v0.1c0 0-0.1 0.1-0.2 0.1q0 0.1-0.1 0.1-0.1 0-0.1-0.1-0.1 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0-0.1 0 0 0 0 0-0.1 0-0.1-0.1 0 0 0 0-0.1 0-0.1 0-0.1 0.1-0.2 0.1 0 0-0.1-0.1 0 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0-0.1 0-0.1 0 0 0-0.1 0 0-0.1 0-0.1 0 0-0.1 0.1 0 0 0 0 0 0-0.1 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0-0.1 0-0.1 0-0.1 0.1-0.1 0.1-0.1 0-0.2-0.1 0 0-0.1 0 0 0 0 0 0 0.1-0.1 0.1 0 0 0 0-0.1 0-0.1 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0.1-0.1 0.1-0.1 0-0.2-0.1c0 0-0.1-0.1-0.1-0.1v-0.1q0 0 0.1 0.1c0.1 0.1 0.2 0.1 0.2 0.1q0.1 0 0.1-0.1v-0.1 0.1q0 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0.1 0.1 0.1c0.1 0 0.2-0.1 0.2-0.2q0-0.1 0-0.1v-0.1 0.1q0 0 0.1 0.1 0 0 0 0 0 0.1 0.1 0.1 0 0 0 0c0.1 0 0.2-0.1 0.2-0.2 0 0 0 0 0 0 0.1 0 0.1 0 0.1 0q0 0 0 0.1 0 0 0 0 0.1 0 0.1 0 0 0.1 0.1 0 0 0.1 0 0 0.1 0 0.1 0 0-0.1 0.1-0.1 0-0.1-0.1-0.1z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s13",
    d: "m11.3 8.2q0.1 0 0 0 0 0 0 0-0.1 0.1 0 0.1 0 0 0-0.1zm-0.8-0.1q0-0.1 0-0.1-0.1 0-0.1 0.1 0 0 0 0 0.1 0 0.1 0zm-0.9 0q0-0.1-0.1-0.1 0 0 0 0.1 0 0 0 0 0.1 0 0.1 0zm-1 0.1q0.1 0.1 0.1 0.1 0 0 0-0.1 0 0 0 0-0.1 0-0.1 0z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m9 7.7q0 0 0 0 0.1 0 0.1 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0.1-0.1 0.1-0.1v0.1q0 0 0 0.1 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0.1-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0-0.1l-0.1-0.1q0.1 0 0.1 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s12",
    d: "m9 8.1q0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0h-0.1q0-0.1-0.1-0.1v0.1q0 0 0 0 0 0 0 0 0 0-0.1 0.1 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0l-0.1 0.1h0.1q0 0 0.1-0.1 0 0 0 0zm0.1 0q0.1 0 0.1 0 0.1 0 0.1 0h0.1q0 0 0 0 0 0-0.1 0 0 0 0 0 0-0.1 0-0.1 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0.1 0-0.1-0.1-0.1-0.1 0 0 0 0 0 0-0.1 0 0 0 0 0h-0.1q-0.1 0.1-0.1 0.1 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0.1z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m9 8q0-0.1 0.1-0.1 0.1 0 0.1 0.1 0 0.1-0.1 0.1 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0-0.1 0-0.1z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m10 7.5q0 0 0 0.1 0 0 0 0 0.1 0 0.1 0 0 0.1 0 0.1 0 0 0 0 0.1 0 0.1 0h-0.1q0 0 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0-0.1 0-0.1 0-0.1h-0.1q0 0 0.1 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0.1 0 0.1 0 0-0.1 0-0.1"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s12",
    d: "m9.9 8l-0.2 0.1v-0.1q0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0-0.1 0 0 0.1 0v-0.1q0.1 0 0.2 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0zm0.2-0.1q0.1 0 0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0-0.1 0-0.1 0 0 0.1 0 0.1 0 0.1 0h0.1q0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0.1 0.1 0.1 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0.1 0 0.1 0 0-0.1 0h0.1-0.1-0.1q0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1-0.1zm1-0.3q0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0h0.1-0.1v0.1q0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0v-0.1-0.1q0 0 0 0h0.1q0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0.1 0 0 0 0 0z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s12",
    d: "m11 8.1q0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1-0.1 0.1-0.1h0.1v0.1q0 0 0 0 0 0 0 0 0 0 0.1 0.1 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0-0.1 0v0.1l-0.1-0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0zm-0.2 0q-0.1 0-0.1 0h-0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0l0.1-0.1q-0.1 0-0.2 0 0.1-0.1 0.1-0.1 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0.1 0 0.1 0 0.1 0.1 0.1 0.1-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s11",
    d: "m10.8 8q0-0.1 0.1-0.1 0.1 0 0.1 0.1 0 0.1-0.1 0.1 0 0 0 0 0 0-0.1 0 0 0 0 0 0-0.1 0-0.1zm1 0.3q-0.1 0-0.1 0-0.1 0 0-0.1 0.1 0 0.1 0 0 0 0 0.1z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s12",
    d: "m11.7 8.3q-0.1 0-0.1 0 0 0 0 0 0 0 0 0c0 0-0.1 0-0.1 0l-0.1-0.1h0.1q0 0 0 0-0.1 0-0.1 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0v-0.1l0.1 0.1q0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0.1 0 0.1c0 0 0-0.1 0-0.2 0 0 0.1 0 0.1 0q0.1 0 0.1 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1c0 0-0.1 0-0.1 0-0.1 0-0.1 0.1-0.1 0.1q0 0-0.1 0 0 0 0 0.1 0 0 0 0zm-3.4 0q0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c0 0 0-0.1-0.1-0.1-0.1 0-0.1 0-0.1 0q0 0 0-0.1 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0.1 0c0 0 0 0 0.1 0 0 0.1 0 0.2 0 0.2q0 0 0-0.1 0 0 0.1 0v-0.1q0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0.1-0.1 0-0.1 0 0 0 0 0h0.1l-0.1 0.1c0 0-0.1 0-0.1 0q0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m8.2 8.2q0 0 0.1 0 0 0.1 0 0.1 0 0-0.1 0 0-0.1 0-0.1m1.7-0.3q0 0 0.1 0 0.1 0 0.1 0 0 0.1-0.1 0.1 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0-0.1z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s15",
    d: "m9.8 6.7c0-0.1 0.1-0.2 0.2-0.2 0.1 0 0.2 0.1 0.2 0.2q0 0 0 0.1-0.1 0-0.1 0 0 0 0 0-0.1 0.1-0.1 0.1 0 0-0.1-0.1 0 0 0 0-0.1 0-0.1 0 0-0.1 0-0.1z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m9.9 6.2v0.1h-0.1v0.1h0.1v0.3h-0.1q0 0 0 0.1h0.3q0.1 0 0.1-0.1 0 0 0 0 0 0 0 0 0 0 0 0h-0.2v-0.3h0.1v-0.1h-0.1v-0.1h-0.1z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m10 13.8q-0.2 0-0.4 0-0.2-0.1-0.3-0.1-0.2-0.1-0.4-0.1-0.2-0.1-0.4-0.2-0.1 0-0.2-0.1-0.1-0.1-0.2-0.2 0-0.1-0.1-0.3 0-0.1 0-0.2v-1.4h4v1.4c0 0.3-0.2 0.7-0.5 0.8q-0.2 0.1-0.4 0.2-0.2 0-0.3 0.1-0.2 0-0.4 0-0.2 0.1-0.4 0.1"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m10 13.8q-0.2 0-0.4 0-0.2-0.1-0.3-0.1-0.2-0.1-0.4-0.1-0.2-0.1-0.4-0.2-0.1 0-0.2-0.1-0.1-0.1-0.2-0.2 0-0.1-0.1-0.3 0-0.1 0-0.2v-1.4h4v1.4c0 0.3-0.2 0.7-0.5 0.8q-0.2 0.1-0.4 0.2-0.2 0-0.3 0.1-0.2 0-0.4 0-0.2 0.1-0.4 0.1z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s9",
    d: "m10 9h2v2.3h-2z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m10 9h2v2.3h-2z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m10 12.6q0 0.2-0.1 0.4-0.1 0.1-0.2 0.3-0.1 0.1-0.3 0.2-0.2 0-0.4 0c-0.6 0-1-0.4-1-0.9v-1.3h2v1.3"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m8.4 13.4q0.1 0 0.3 0.1v-2.3h-0.3v2.2z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s16",
    d: "m8 12.6q0 0.1 0 0.1 0 0.1 0.1 0.2 0 0.1 0 0.2 0.1 0 0.1 0.1v-2h-0.2v1.4z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s17",
    d: "m8.9 13.5q0.1 0 0.2 0v-2.3h-0.2z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m9.3 13.5q0.1 0 0.1 0 0-0.1 0-0.1 0.1 0 0.1 0 0 0 0.1 0v-2.2h-0.3v2.3z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m8 9h2v2.3h-2z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m8 9h2v2.3h-2z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m9.8 13.2c0.1-0.1 0.2-0.3 0.2-0.5v-1.5h-0.2v2z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m10 12.6q0 0.2-0.1 0.4-0.1 0.1-0.2 0.3-0.1 0.1-0.3 0.2-0.2 0-0.4 0c-0.6 0-1-0.4-1-0.9v-1.3h2v1.3"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m12 11.3v1.3q0 0.2-0.1 0.4 0 0.1-0.2 0.3-0.1 0.1-0.3 0.2-0.2 0-0.4 0c-0.5 0-1-0.4-1-0.9v-1.4z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12 11.3v1.3q0 0.2-0.1 0.4 0 0.1-0.2 0.3-0.1 0.1-0.3 0.2-0.2 0-0.4 0c-0.5 0-1-0.4-1-0.9v-1.4z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s4",
    d: "m10.6 12.3h0.1 0.6 0.1 0.2q0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0h0.1q0 0 0 0 0 0 0 0-0.1 0.1-0.1 0.1 0 0 0 0v0.1h0.1v0.2h-0.1q0 0.1-0.1 0.1h0.1q0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0-0.1 0 0 0-0.1 0 0 0 0 0 0 0.1 0 0.1-0.1 0-0.1 0 0 0 0 0 0 0 0 0l0.1 0.1q-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0.1 0 0.1l-0.1-0.1q0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0.1 0 0.1 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0-0.1 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0v-0.1q0.1 0.1 0.2 0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0.1 0 0.1 0v-0.3-0.1-0.3l-0.2 0.2v-0.1 0.1l-0.1 0.1h-0.1l-0.1 0.2q0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0.1 0 0.1 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0-0.1 0.1 0 0.1 0 0 0 0 0.1 0 0 0.1 0 0 0 0 0v0.1q0-0.1-0.1-0.1 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0-0.1 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1h0.1q0 0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0 0l0.1-0.1v-0.1l0.1 0.1 0.1-0.1h-0.1l0.2-0.3q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0h-0.1v0.1h-0.2v-0.1h-0.2q0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0v0.1 0.1c0 0 0 0.1 0 0.1v-0.1-0.1h-0.1v0.1q0 0 0 0 0 0 0 0.1 0 0 0 0h-0.1v-0.2h0.1v-0.1q0 0 0 0-0.1-0.1-0.1-0.1 0 0 0 0 0 0 0 0h0.1q0 0 0 0 0 0 0 0 0.1 0 0.1 0zm0.4 0.8q0 0 0 0 0 0 0 0 0 0 0 0.1 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1-0.1 0 0 0 0v0.1q0.1 0 0.1 0 0 0 0-0.1 0 0 0 0 0.1-0.1 0.1-0.1 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0l-0.1-0.2v-0.1h-0.1l-0.2-0.2v0.3h0.1v0.2h-0.1zm0.1-0.8q0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0l0.2 0.2h0.1l0.1 0.1 0.1 0.2q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1-0.1 0 0 0 0 0 0 0 0l-0.1-0.1c0 0 0-0.1 0 0v-0.1h0.1v-0.1q-0.1-0.1-0.1-0.1h-0.1v0.1h-0.2v-0.1zm0.5 0.4q0-0.1 0-0.1h0.1v-0.1h-0.1v0.1 0.1q0 0 0 0zm-1.3 0.2q0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0.1 0 0 0 0-0.1 0-0.1 0zm0-0.2q0 0 0 0 0 0 0 0zm0.2 0.4q0 0 0 0 0 0 0 0zm0.1 0q0 0 0 0 0 0.1 0.1 0.1 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0v-0.1q0 0 0.1 0zm0-0.5h-0.1l0.1-0.1h0.1zm1 0.2q0 0 0 0 0 0 0 0zm0 0q0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0.1 0 0.1 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0zm-0.2 0.2q0 0 0 0-0.1 0-0.1 0 0 0 0 0.1-0.1 0-0.1 0v-0.1q0 0 0 0 0 0 0.1 0 0 0 0 0 0-0.1 0-0.1l0.1 0.1zm-0.1-0.4v0.1l-0.1-0.2 0.1 0.1zm-0.3 0.5q0 0.1 0 0.1 0 0 0-0.1 0 0 0 0 0 0 0 0zm-0.1-0.5v0.2h0.1v-0.2z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s4",
    d: "m10.2 12.3q0 0 0 0m0.1-0.1v-0.2h-0.1v-0.2h0.1v-0.2q-0.1 0-0.1-0.1 0 0 0 0 0 0 0.1 0 0-0.1 0-0.1 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0h0.2v-0.1h0.2v0.1h-0.2v0.1h-0.2l0.2 0.2h0.1l0.1 0.1v0.1l0.2 0.2v-0.3-0.1-0.2q0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0h-0.1-0.2 0.1v-0.1h0.2q0 0 0 0 0 0 0 0 0-0.1 0.1-0.1 0 0 0 0 0.1 0 0.1 0.1h0.2v0.1h-0.1-0.1q0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0v0.1h0.1v0.2h-0.1v0.3l0.2-0.2h0.1l-0.2 0.2h0.1 0.1v0.1h-0.6v-0.1h-0.1v0.1h-0.2q0-0.1 0-0.1 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1h-0.1q0-0.1 0.1-0.1zm0.9 0h0.2-0.1zm-0.3 0l-0.2-0.2-0.1-0.1-0.3-0.3v0.3 0.1 0.2q0.1 0 0.1 0h0.1 0.2zm0.4-0.2l-0.1-0.1 0.1-0.1h0.1l-0.1 0.2v-0.1zm0.2 0.3h0.1q0.1 0 0.1 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0v-0.1h-0.1v-0.2h0.1v-0.2q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0l-0.2 0.2v0.1l-0.1 0.1h-0.1l0.2-0.2v0.1l-0.1-0.1 0.3-0.3q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0h-0.2v0.1h-0.2v-0.1h0.1 0.1 0.2q0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0.1 0.1 0 0.1-0.1 0.1v0.2h-0.1v0.1h0.1v-0.1h0.1v0.2h-0.1v0.1q0 0 0 0 0 0.1 0 0.1 0 0 0.1 0 0 0 0 0h-0.1q0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0zm-1-0.4h0.1v0.2h-0.1zm0.4 0.2h-0.1l-0.1-0.1v-0.1zm-0.4-0.5q0 0.1 0 0.1 0.1 0 0.1-0.1 0 0-0.1 0 0 0 0 0zm1.4 0q0 0 0 0-0.1 0-0.1 0 0 0.1 0.1 0.1 0 0 0-0.1zm-0.7 0q0 0 0 0-0.1 0-0.1 0 0 0.1 0.1 0.1 0 0 0-0.1zm0.2 0zm0-0.1h0.2v0.1h-0.2zm-0.3 0.3v0.2-0.2z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s18",
    d: "m11.1 13.2q0 0 0 0 0.1 0 0.1 0 0 0 0 0 0-0.1 0.1-0.1v0.1q0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0.1 0 0.1 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0-0.1 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0v-0.1q0.1 0.1 0.2 0.1 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0.1 0 0.1 0v-0.3 0.3q0 0 0.1 0 0 0 0 0 0 0 0 0.1 0 0 0 0zm-0.3 0q-0.1 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1-0.1 0 0 0 0l-0.1 0.1q0.1 0 0.1 0 0 0 0 0 0 0 0.1 0 0 0.1 0 0.1l0.1-0.1q0 0 0 0zm0.1-0.9q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0h-0.2v-0.1h0.2q0 0 0 0l-0.2-0.2 0.3 0.2q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0v-0.3 0.3l0.2-0.3 0.1 0.1-0.2 0.2h0.2v0.1h-0.2l0.2 0.3h-0.1l-0.2-0.2v0.3-0.3l-0.2 0.2h-0.1zm-0.5-0.7v0.2h-0.1v-0.2q-0.1-0.1-0.1-0.1 0-0.1 0-0.1 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0h0.2v0.1h-0.2l0.3 0.3h-0.1l-0.2-0.2zm0.2 1.4q0 0 0 0 0 0 0 0v-0.1q0.1 0 0.1 0 0 0.1 0 0.1 0 0 0.1 0 0 0 0 0v0.1q0 0-0.1 0 0-0.1 0-0.1 0 0-0.1 0 0 0 0 0zm0 0.1q0-0.1 0-0.1 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0-0.1 0-0.1-0.1 0-0.1 0-0.1 0-0.1 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0-0.1 0-0.1 0 0 0 0h0.1q0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0 0l0.1-0.2 0.1 0.1-0.2 0.2q0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0.1 0 0.1 0.1 0 0 0 0 0 0 0 0 0 0 0 0zm-0.3-0.4v-0.1-0.1-0.1-0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0-0.1v-0.2h0.1v0.2q0 0.1 0.1 0.1h0.1v0.1h-0.1q0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0v0.1l0.1 0.1q0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0l-0.1 0.1v-0.2h-0.1q0 0.1 0 0.1 0 0 0 0.1 0 0 0 0zm0.1 0.1q0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0zm-0.1-0.1q0 0 0 0zm0.3 0.4q0 0 0 0 0 0 0 0z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s18",
    d: "m10.8 12.5v0.1l-0.1 0.1h-0.1zm-0.2 0.1l0.1-0.2 0.1 0.1zm-0.3-0.4q0 0 0 0 0-0.1 0-0.1 0.1 0 0.1 0.1 0 0-0.1 0zm1.1 0.8q0-0.1 0-0.1 0 0 0 0 0.1 0 0.1 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0l-0.2-0.2 0.1-0.1 0.1 0.2q0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0-0.1h0.1v0.1q0 0.1-0.1 0.1 0.1 0.1 0.1 0.1 0 0 0 0 0 0 0 0.1 0 0-0.1 0 0 0-0.1 0 0 0 0 0 0 0.1 0 0.1-0.1 0-0.1 0 0 0 0 0h-0.1q0.1 0 0.1 0zm0.3-0.5v-0.1h-0.1v0.1 0.1q0 0 0 0h-0.1c0 0 0.1-0.2 0.1-0.1v-0.1-0.1q0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0h-0.2v-0.1h0.2q0 0 0 0v-0.2h0.1v0.2q0 0 0 0 0 0 0.1 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0-0.1 0-0.1 0.1 0 0 0 0v0.1h0.1v0.2h-0.1q0 0 0-0.1zm-0.1 0.3q0 0 0 0 0 0 0 0zm0 0q0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0.1 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0zm0.1-1.3v0.3h-0.1v-0.3q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0l-0.2 0.3h-0.1l0.3-0.3q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0h-0.2v-0.1h0.2q0 0 0 0 0 0 0 0 0-0.1 0-0.1 0.1 0 0.1 0 0.1 0 0.1 0.1 0 0.1-0.1 0.1zm-0.7 0v0.2-0.2q0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0h-0.2v-0.1h0.2q0 0 0 0 0 0 0 0 0-0.1 0.1-0.1 0 0 0 0 0.1 0 0.1 0.1h0.2v0.1h-0.2q0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0zm0.4 1.4q0 0.1 0 0.1-0.1 0-0.1 0 0 0 0 0-0.1 0-0.1 0.1v-0.1q0 0 0 0 0.1 0 0.1 0 0-0.1 0-0.1 0 0 0.1 0zm0 0.1q0 0 0 0.1-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0.1-0.1 0.1-0.1 0 0 0 0 0.1 0 0.1 0zm-1.2-1.2v-0.2zm0.1-0.2h0.1v0.2h-0.1zm1.2 0v0.2h0.1v-0.2z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s18",
    d: "m11.7 11.8h0.1v0.2h-0.1zm-0.4 0.9v0.1l-0.1-0.2zm-0.1-0.2l0.1-0.1 0.1 0.2h-0.1zm-0.6-0.6l0.1-0.1 0.1 0.2zm0.1 0.2l-0.1 0.1-0.1-0.2zm0.5-0.1l0.1-0.2 0.1 0.1zm0.2-0.2v0.1l-0.1 0.1h-0.1l0.2-0.2zm-0.9 0.4v-0.1h0.2v0.1zm0.3 0.1h-0.1-0.1-0.1zm-0.5-0.8q0 0 0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0zm0.5 0v0.1h-0.2v-0.1zm-0.2 0v-0.1h0.2v0.1zm1.1 0.8q0 0 0-0.1 0 0 0 0 0.1 0 0.1 0 0 0.1-0.1 0.1zm-0.4-0.1v-0.1h0.2v0.1zm0.2 0.1h-0.2zm-0.5 0.9q0-0.1 0-0.1 0.1 0 0.1 0.1 0 0-0.1 0 0 0 0 0zm0.1-0.6v0.1 0.1 0.1zm-0.1 0.2h-0.1v-0.2h0.1zm0.7-1.4q0 0 0 0 0 0 0 0 0 0 0.1 0-0.1 0-0.1 0zm-0.7 0q0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0-0.1 0zm0.5 0v0.1h-0.2l-0.1-0.1zm-0.2 0v-0.1h0.2v0.1zm-0.2 0.4h-0.1v-0.2h0.1zm0.1-0.2v0.2z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s7",
    d: "m10.9 12.3q0 0 0-0.1 0 0 0 0 0 0 0.1 0 0 0 0 0 0.1 0 0.1 0.1 0 0 0 0 0 0 0 0.1 0 0-0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0-0.1 0-0.1 0 0 0 0z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m11 9.6v-0.1c0 0 0 0-0.1 0q0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0-0.1 0-0.1-0.1 0-0.1 0 0 0 0 0.1 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1c0 0 0.1 0 0.2 0z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11 9.6v-0.1c0 0 0 0-0.1 0q0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0-0.1 0-0.1-0.1 0-0.1 0 0 0 0 0.1 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1c0 0 0.1 0 0.2 0z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s20",
    d: "m11.3 9.5q0 0.1 0 0.1 0 0.1 0 0.1v-0.1 0.1q0 0 0 0 0 0.1 0.1 0.1c0 0 0 0 0 0q0 0-0.1 0c0 0 0 0 0 0q0 0.1 0 0.1 0 0 0 0l-0.1-0.1c0 0 0 0.1 0 0.1v0.1q0 0 0 0v-0.1c0 0 0 0.1 0 0.1q0 0 0.1 0.2c0 0 0.1 0.1 0.2 0.1 0.1-0.1 0.1-0.2 0-0.3 0-0.1 0-0.2 0-0.2 0 0 0-0.1 0-0.1q0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0.1-0.1v-0.1 0.1 0.1c0 0 0-0.1 0.1-0.1q0 0 0-0.1h0.1c0 0 0 0.1-0.1 0.1v0.1q0 0 0 0 0 0 0 0.1c0 0 0 0-0.1 0 0 0.1 0 0.1 0 0.1-0.1 0 0 0.2 0 0.2 0 0 0 0.2 0 0.2 0 0.1 0 0.2 0 0.2-0.1 0.1-0.1 0.1-0.2 0.1q0 0 0 0.1c0 0.1 0 0.1 0 0.1q0.1 0 0.1 0 0 0.1 0 0.1c0 0 0 0 0 0.1 0 0-0.1 0-0.1 0.1q0 0 0 0c0 0 0.1 0 0 0.1q0 0 0-0.1v0.1q0 0 0-0.1h-0.1q0 0 0 0 0 0 0 0.1 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0-0.1-0.1 0 0 0 0 0 0 0.1 0c0 0 0 0 0 0q0 0 0 0 0.1-0.1 0-0.1 0 0 0 0v-0.1 0.1c-0.1 0-0.1-0.1-0.1-0.1v0.1q0 0 0 0c0 0 0 0 0 0q0 0 0 0l-0.1-0.1c0 0 0-0.1 0-0.1h0.1-0.1q0 0-0.1 0 0 0 0 0.1 0.1 0.1 0.1 0.1 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0-0.1 0 0 0 0 0 0 0.1 0 0.1-0.1 0-0.1-0.1 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0c0-0.1-0.1-0.1 0-0.1q0 0 0 0 0 0 0 0 0 0 0 0v-0.1q0 0 0.1 0c0 0 0 0 0 0.1q0 0 0.1 0 0 0 0 0v-0.1q0 0 0 0v0.1-0.1-0.1 0.1q-0.1 0-0.1 0v-0.1c0.1 0 0.1-0.1 0.1-0.1h0.1 0.1c0 0-0.1-0.1-0.1-0.1-0.1 0-0.1 0-0.1-0.1q0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0l-0.1 0.1v-0.1c0 0 0 0 0 0.1v-0.1q0 0-0.1 0.1c0 0-0.1 0-0.1 0q0 0 0 0 0 0.1 0 0.1 0-0.1 0-0.1 0 0 0 0-0.1 0-0.1 0c0 0 0.1 0 0.1 0q0 0-0.1 0 0 0 0 0 0 0 0-0.1 0 0 0 0c0 0 0.1 0 0.1 0q0 0-0.1 0 0 0 0 0v-0.1q0 0 0.1 0 0 0 0 0.1c0 0 0.1 0 0.1-0.1h0.1v-0.1h-0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0c0 0 0-0.1 0-0.1q0 0 0 0h0.1-0.1q0 0-0.1 0 0 0 0.1 0c0 0 0-0.1 0-0.1h-0.1q0 0 0 0 0 0 0 0-0.1 0-0.1 0v-0.1q0 0 0 0h0.1q0 0 0 0-0.1 0-0.1-0.1h0.1q0 0 0 0c0 0 0 0 0 0q0.1 0 0 0 0 0 0.1-0.1 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0.1 0 0.1c0 0 0.1 0 0.1 0q0.1 0 0.1 0c0 0 0.1 0 0.1 0q0 0 0 0c0 0 0-0.1 0-0.1q0 0 0 0c0.1 0 0.1 0 0.1 0q0-0.1 0-0.1-0.1 0-0.1 0 0-0.1 0-0.1 0 0 0.1 0 0 0 0 0 0 0 0.1-0.1 0 0 0.1 0.1c0.1 0 0.1 0.1 0.1 0.1"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m10.9 9.5v-0.1c0 0 0 0 0 0q0 0 0 0 0 0 0 0"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m10.9 9.5v-0.1c0 0 0 0 0 0q0 0 0 0 0 0 0 0z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m11.1 9.4q0 0 0 0 0.1 0 0.1 0-0.1 0-0.1 0 0 0 0 0z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.1 9.4q0 0 0 0 0.1 0 0.1 0-0.1 0-0.1 0 0 0 0 0z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.3 9.6q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m10.5 9.4q0 0.1 0 0.1 0 0 0-0.1c0 0 0 0 0 0q0 0 0 0 0 0 0 0z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m10.5 9.4q0 0.1 0 0.1 0 0 0-0.1c0 0 0 0 0 0q0 0 0 0 0 0 0 0z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m10.4 9.5c0 0 0 0-0.1 0q0 0 0 0 0 0 0 0h0.1z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m10.4 9.5c0 0 0 0-0.1 0q0 0 0 0 0 0 0 0h0.1z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m10.3 9.6q0 0 0 0c0 0.1 0 0.1 0 0.1q0 0 0 0h0.1l-0.1-0.1q0 0 0 0z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m10.3 9.6q0 0 0 0c0 0.1 0 0.1 0 0.1q0 0 0 0h0.1l-0.1-0.1q0 0 0 0z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m10.9 9.6z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m10.9 9.6z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m10.9 9.6h0.1-0.1"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m10.9 9.6h0.1-0.1"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m10.9 9.5h0.1-0.1z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m10.9 9.5h0.1-0.1z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m11 9.5z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11 9.5z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.2 9.9h-0.1q0 0.1 0 0.1 0 0 0 0c0 0 0 0 0 0q0-0.1 0-0.1h-0.1q0 0.1 0 0.1 0 0 0 0 0 0 0 0v-0.1q0 0 0 0h-0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0l-0.1 0.1q0-0.1 0-0.1 0 0 0-0.1c0 0 0.1 0 0.1 0q-0.1 0-0.1 0-0.1 0-0.1 0 0 0 0 0 0-0.1 0.1-0.1m-0.1 0.3q0-0.1 0-0.1h0.1zm0.2 0.1l0.1-0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m10.4 10q0 0 0 0c0 0-0.1 0-0.1 0h0.1q0 0.1 0 0.1v-0.1z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m10.4 10q0 0 0 0c0 0-0.1 0-0.1 0h0.1q0 0.1 0 0.1v-0.1z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m10.4 10.1q0 0 0 0-0.1 0.1-0.1 0.1 0 0 0.1 0 0-0.1 0-0.1z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m10.4 10.1q0 0 0 0-0.1 0.1-0.1 0.1 0 0 0.1 0 0-0.1 0-0.1z"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m10.5 10.2q-0.1 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0-0.1"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m10.5 10.2q-0.1 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0-0.1zm0.7 0.3c0 0 0-0.1 0-0.1 0-0.1 0-0.1 0-0.1z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m10.8 10.5q-0.1 0-0.1 0c0 0-0.1 0-0.1 0 0 0 0.1 0 0.1 0v0.1z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m10.8 10.5q-0.1 0-0.1 0c0 0-0.1 0-0.1 0 0 0 0.1 0 0.1 0v0.1z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m10.7 10.6c0 0-0.1 0-0.1 0.1q0 0 0 0c0 0 0 0 0 0q0.1 0 0.1 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m10.7 10.6c0 0-0.1 0-0.1 0.1q0 0 0 0c0 0 0 0 0 0q0.1 0 0.1 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m10.7 10.8q0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m10.7 10.8q0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m11.2 10.8q0 0 0 0c0 0 0 0.1 0 0.1q0 0 0-0.1v0.1-0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.2 10.8q0 0 0 0c0 0 0 0.1 0 0.1q0 0 0-0.1v0.1-0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m11.3 10.9q-0.1 0-0.1 0.1 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0v-0.1z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.3 10.9q-0.1 0-0.1 0.1 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0v-0.1z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s19",
    d: "m11.4 11c0 0 0 0 0 0q0 0 0 0c0 0 0 0 0 0q0 0 0 0v-0.1z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.4 11c0 0 0 0 0 0q0 0 0 0c0 0 0 0 0 0q0 0 0 0v-0.1z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s22",
    d: "m10.1 13.2q0.1 0 0.1 0.1c0 0.1-0.1 0.2-0.2 0.2-0.1 0-0.2-0.1-0.2-0.2 0 0 0-0.1 0.1-0.1q0 0 0 0v-0.1l0.1 0.1v-0.1q0 0 0 0l0.1 0.1q0-0.1 0-0.1v0.1z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s14",
    d: "m9.8 13.6q-0.1 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0-0.1h-0.1c0.1 0 0.2 0 0.3 0 0 0 0.2 0.1 0.2 0.1 0 0-0.1 0.1-0.2 0zm0.2 0c0 0 0.1-0.1 0.3-0.1 0.1 0 0.2 0 0.2 0q0 0-0.1 0.1c0 0 0 0-0.1 0-0.1 0-0.2 0-0.2 0z"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s11",
    d: "m10 13.5q0 0 0-0.1 0 0 0-0.1 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0.1 0 0.1 0.1 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0-0.1 0.1 0 0 0 0z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s14",
    d: "m10 13.7c0 0 0-0.1 0-0.1v-0.1q0 0 0 0.1v0.1"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m12 7.9q0 0 0 0 0.1 0 0.1 0 0 0.1-0.1 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12 7.9q0 0 0 0 0.1 0 0.1 0 0 0.1-0.1 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1z"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m12 7.8q0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0-0.1-0.1-0.1-0.1z"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12 7.8q0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0-0.1-0.1-0.1-0.1z"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m12.1 7.7q0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0.1-0.1 0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0z"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.1 7.7q0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0.1-0.1 0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0z"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m12.1 7.6q0-0.1 0-0.1 0 0 0.1 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0z"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.1 7.6q0-0.1 0-0.1 0 0 0.1 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0z"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m12.1 7.5q0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.1 7.5q0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m12 7.3q0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1-0.1 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12 7.3q0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1-0.1 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1z"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m11.9 7.2q0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1-0.1 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1z"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.9 7.2q0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1-0.1 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1z"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m11.8 7.2q0-0.1 0-0.1 0.1 0 0.1 0.1 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.8 7.2q0-0.1 0-0.1 0.1 0 0.1 0.1 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m11.7 7.1q0 0 0 0 0.1 0 0.1 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.7 7.1q0 0 0 0 0.1 0 0.1 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m11.5 7q0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0-0.1z"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.5 7q0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0-0.1z"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m11.4 7q0 0 0 0 0.1 0 0.1 0 0 0.1-0.1 0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.4 7q0 0 0 0 0.1 0 0.1 0 0 0.1-0.1 0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0z"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m11.3 7q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0-0.1 0.1-0.1 0.1 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.3 7q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0-0.1 0.1-0.1 0.1 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0z"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m11.1 7q0 0 0.1 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0-0.1 0-0.1-0.1 0 0 0 0 0 0 0 0z"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.1 7q0 0 0.1 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0-0.1 0-0.1-0.1 0 0 0 0 0 0 0 0z"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m11 7q0 0 0 0 0.1 0 0.1 0 0 0.1-0.1 0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0z"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11 7q0 0 0 0 0.1 0 0.1 0 0 0.1-0.1 0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0z"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m11.1 7.1q0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1zm0 0.2q0-0.1 0-0.1 0.1 0 0.1 0.1 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0zm0 0.1q0 0 0 0 0-0.1 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0zm0 0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0m-0.1 0.1q0 0 0 0 0.1 0 0.1 0 0 0.1-0.1 0.1 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0z"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m10.9 6.9q0 0 0 0 0.1 0 0.1 0 0 0.1-0.1 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m10.9 6.9q0 0 0 0 0.1 0 0.1 0 0 0.1-0.1 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1z"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m10.8 6.9q0-0.1 0-0.1 0.1 0 0.1 0.1 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m10.8 6.9q0-0.1 0-0.1 0.1 0 0.1 0.1 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m10.6 6.8q0 0 0.1 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0-0.1 0-0.1-0.1 0 0 0 0"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m10.6 6.8q0 0 0.1 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0-0.1 0-0.1-0.1 0 0 0 0z"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m10.5 6.8q0 0 0 0 0.1 0 0.1 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m10.5 6.8q0 0 0 0 0.1 0 0.1 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m10.4 6.8q0 0 0 0 0 0 0.1 0-0.1 0-0.1 0.1 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m10.4 6.8q0 0 0 0 0 0 0.1 0-0.1 0-0.1 0.1 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m10.2 6.8q0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0-0.1 0-0.1z"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m10.2 6.8q0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0-0.1 0-0.1z"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m10.1 6.9q0-0.1 0-0.1 0.1 0 0.1 0.1 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m10.1 6.9q0-0.1 0-0.1 0.1 0 0.1 0.1 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m7.9 7.9q0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1-0.1 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7.9 7.9q0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1-0.1 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1z"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m7.8 7.8q0 0 0.1 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0-0.1 0 0-0.1 0-0.1z"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7.8 7.8q0 0 0.1 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0-0.1 0 0-0.1 0-0.1z"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m7.8 7.7q0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1-0.1 0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0z"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7.8 7.7q0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1-0.1 0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0z"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m7.8 7.6q0-0.1 0-0.1 0.1 0 0.1 0.1 0 0-0.1 0 0 0 0 0"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7.8 7.6q0-0.1 0-0.1 0.1 0 0.1 0.1 0 0-0.1 0 0 0 0 0z"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m7.8 7.5q0-0.1 0.1-0.1 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0z"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7.8 7.5q0-0.1 0.1-0.1 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0z"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m7.9 7.3q0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1-0.1 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7.9 7.3q0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1-0.1 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1z"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m8 7.3q0 0 0-0.1 0 0 0 0 0.1 0 0.1 0 0 0.1-0.1 0.1z"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m8 7.3q0 0 0-0.1 0 0 0 0 0.1 0 0.1 0 0 0.1-0.1 0.1z"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m8.1 7.2q0-0.1 0-0.1 0.1 0 0.1 0.1 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m8.1 7.2q0-0.1 0-0.1 0.1 0 0.1 0.1 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m8.2 7.1q0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m8.2 7.1q0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m8.3 7q0.1 0 0.1 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1-0.1z"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m8.3 7q0.1 0 0.1 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1-0.1z"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m8.5 7q0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1-0.1 0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0z"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m8.5 7q0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1-0.1 0.1 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0z"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m8.6 7q0 0 0.1 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0-0.1-0.1 0 0 0 0 0 0 0 0z"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m8.6 7q0 0 0.1 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0-0.1-0.1 0 0 0 0 0 0 0 0z"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m8.8 7q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0z"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m8.8 7q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0z"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m8.9 7q0 0 0 0 0.1 0 0.1 0 0 0.1-0.1 0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0z"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m8.9 7q0 0 0 0 0.1 0 0.1 0 0 0.1-0.1 0.1 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0z"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s13",
    d: "m8.8 7.1q0 0 0.1 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0-0.1 0 0 0 0 0 0-0.1 0-0.1m0 0.2q0 0 0 0 0-0.1 0-0.1 0.1 0 0.1 0.1 0 0-0.1 0zm0 0.1q0 0 0 0 0.1 0 0.1 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0zm0 0.1q0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0m0.1 0.1q0 0 0.1 0 0 0 0 0 0 0.1 0 0.1-0.1 0-0.1-0.1 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m9 6.9q0 0 0 0 0.1 0 0.1 0 0 0.1-0.1 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m9 6.9q0 0 0 0 0.1 0 0.1 0 0 0.1-0.1 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1z"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m9.1 6.9q0-0.1 0.1-0.1 0 0 0 0.1 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0z"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m9.1 6.9q0-0.1 0.1-0.1 0 0 0 0.1 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0z"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m9.3 6.8q0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m9.3 6.8q0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0z"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m9.4 6.8q0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m9.4 6.8q0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m9.5 6.8q0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0-0.1-0.1-0.1-0.1 0 0 0 0 0 0 0 0z"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m9.5 6.8q0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0-0.1-0.1-0.1-0.1 0 0 0 0 0 0 0 0z"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m9.7 6.8q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0.1-0.1 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m9.7 6.8q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0 0.1-0.1 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1z"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s6",
    d: "m9.8 6.9q0-0.1 0-0.1 0.1 0 0.1 0.1 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m9.8 6.9q0-0.1 0-0.1 0.1 0 0.1 0.1 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s12",
    d: "m8.7 9.5h-0.1v0.1 0.1h-0.1v0.3h0.1v0.6h-0.2v0.3h1.2v-0.3h-0.2v-0.6h0.1v-0.3h-0.1v-0.1-0.1h-0.1-0.1-0.1v0.1h0.1v0.1h-0.1v-0.3-0.1h-0.1-0.1v0.1 0.3h-0.1v-0.1h0.1v-0.1h-0.1-0.1zm-0.3 1.4h1.2m-1.2 0h1.2m-1.2-0.1h1.2m-1.2-0.1h1.2m-1.2-0.1h1.2m-1 0h0.8m-0.8-0.1h0.8m-0.8-0.1h0.8m-0.8-0.1h0.8m-0.8 0h0.8m-0.8-0.1h0.8m-0.8-0.1h0.8m-0.9-0.1h1m-1 0h1m-1-0.1h1m-1-0.1h1m-0.9 0h0.7m-0.4-0.1h0.2m-0.2-0.1h0.2m-0.2-0.1h0.2m-0.2 0h0.2m-0.2-0.1h0.2m-0.5 0.3h0.2m-0.2-0.1h0.2m-0.2 1.3m0-0.1v-0.1m-0.1 0.1v0.1m0.1 0v-0.1m0.1 0.1m0-0.1v-0.1m0-0.1m0-0.1v-0.1m-0.1 0.3v-0.1m-0.1 0.1v-0.1m0.3 0v0.1m0.1-0.1m-0.3-0.1v0.1m0.2-0.1v0.1m0.1-0.1v0.1m0-0.1v-0.1m0-0.1v0.1m0-0.2v0.1m0-0.2v0.1m0-0.1m-0.1-0.1v0.1m-0.2-0.1v0.1m0-0.1v0.1m0.1-0.1v0.1m0.2-0.1v0.1m0-0.2v0.1m-0.1-0.1v0.1m-0.2-0.1v0.1m0-0.2v0.1m0.2-0.1v0.1m-0.1-0.2v0.1m0.6-0.1h-0.1m0.2-0.1h-0.3m0.3 1.3m0-0.1v-0.1m0.1 0.1v0.1m-0.2 0v-0.1m0 0.1m0-0.1v-0.1m0-0.1m0-0.1v-0.1m0.1 0.3v-0.1m0.1 0.1v-0.1m-0.3 0v0.1m-0.1-0.1m0.2-0.1v0.1m-0.1-0.1v0.1m-0.1-0.1v0.1m0-0.1v-0.1m0-0.1v0.1m0-0.2v0.1m0-0.2v0.1m0-0.1m0.1-0.1v0.1m0.2-0.1v0.1m0-0.1v0.1m-0.1-0.1v0.1m-0.2-0.1v0.1m0-0.2v0.1m0.1-0.1v0.1m0.1-0.1v0.1m0.1-0.2v0.1m-0.3-0.1v0.1m0.2-0.2v0.1m-0.3 0.7v-0.1m0-0.2v-0.1m0 0.2m0-0.3m0-0.1v-0.1m0-0.1v-0.1m0-0.1m-0.4 0.2h0.2m0.1-0.3h0.2m0.1 0.3h0.1"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s12",
    d: "m9.2 10.9v-0.2c0 0 0-0.1-0.2-0.1-0.2 0-0.2 0.1-0.2 0.1v0.2z"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s12",
    d: "m8.9 10.8l-0.1-0.1q0 0 0-0.1l0.1 0.1q0 0 0 0.1zm0.2-0.1l0.1-0.1q0 0.1 0 0.1l-0.1 0.1q0-0.1 0-0.1zm-0.1 0l-0.1-0.1q0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0 0l-0.1 0.1zm-0.1-0.3h-0.2v-0.2q0-0.1 0.1-0.1 0.1 0 0.1 0.1zm0.3-0.2q0-0.1 0.1-0.1 0.1 0 0.1 0.1v0.2h-0.2zm-0.2-0.3v-0.2h0.2l-0.1 0.2zm0.3 0v-0.2h0.2v0.2zm-0.6 0v-0.2h0.2v0.2z"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s23",
    d: "m8.9 10.9v-0.1q0 0 0-0.1 0 0 0 0 0 0 0.1 0 0 0 0 0c0.1 0 0.1 0 0.1 0.1v0.1zm-0.2-0.5v-0.2q0 0 0.1-0.1 0.1 0.1 0.1 0.1v0.2zm0.5 0v-0.2q0 0 0.1-0.1 0 0.1 0 0.1v0.2z"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m10 12c-0.4 0-0.6-0.4-0.6-0.8 0-0.4 0.2-0.7 0.6-0.7 0.4 0 0.7 0.3 0.7 0.7 0 0.4-0.3 0.8-0.7 0.8z"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m10 12c-0.4 0-0.6-0.4-0.6-0.8 0-0.4 0.2-0.7 0.6-0.7 0.4 0 0.7 0.3 0.7 0.7 0 0.4-0.3 0.8-0.7 0.8z"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s8",
    d: "m10 11.8c-0.2 0-0.5-0.3-0.5-0.6 0-0.3 0.3-0.5 0.5-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.3-0.2 0.6-0.5 0.6z"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m10 11.8c-0.2 0-0.5-0.3-0.5-0.6 0-0.3 0.3-0.5 0.5-0.5 0.3 0 0.5 0.2 0.5 0.5 0 0.3-0.2 0.6-0.5 0.6z"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m9.8 10.9c0 0-0.1 0-0.1 0.1q0 0.1 0.1 0.1 0 0-0.1 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0-0.1 0 0 0 0 0h0.1v0.1q0 0 0 0 0 0 0 0v0.1h0.1 0.1l-0.1-0.1h0.1-0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0 0v-0.1q0 0 0-0.1-0.1 0-0.1 0.1 0 0 0-0.1c0-0.1 0-0.1 0-0.1"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m9.8 10.9c0 0-0.1 0-0.1 0.1q0 0.1 0.1 0.1 0 0-0.1 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0-0.1 0 0 0 0 0h0.1v0.1q0 0 0 0 0 0 0 0v0.1h0.1 0.1l-0.1-0.1h0.1-0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0 0v-0.1q0 0 0-0.1-0.1 0-0.1 0.1 0 0 0-0.1c0-0.1 0-0.1 0-0.1z"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m9.7 11.2h0.2-0.2z"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m9.7 11.2h0.2-0.2z"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m10.2 10.9c0 0 0 0 0 0.1q0 0.1 0 0.1 0-0.1-0.1-0.1 0 0.1 0 0.1v0.1q0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0h-0.1 0.1l-0.1 0.1h0.1 0.1v-0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0l0.1-0.1q0 0-0.1-0.1 0 0-0.1 0.1 0.1 0 0.1-0.1c0-0.1-0.1-0.1-0.1-0.1"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m10.2 10.9c0 0 0 0 0 0.1q0 0.1 0 0.1 0-0.1-0.1-0.1 0 0.1 0 0.1v0.1q0 0 0 0 0 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0h-0.1 0.1l-0.1 0.1h0.1 0.1v-0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0l0.1-0.1q0 0-0.1-0.1 0 0-0.1 0.1 0.1 0 0.1-0.1c0-0.1-0.1-0.1-0.1-0.1z"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m10.1 11.2h0.2-0.2z"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m10.1 11.2h0.2-0.2z"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m10 11.2c0 0-0.1 0.1-0.1 0.2q0.1 0 0.1 0.1 0-0.1 0-0.1 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0.1 0 0.1 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0h-0.1 0.1l-0.1 0.1h0.1 0.1l-0.1-0.1h0.1-0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0.1-0.1 0 0 0 0 0 0 0.1 0-0.1-0.1-0.1-0.1 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0.1c0 0 0.1-0.1 0.1-0.2 0 0-0.1-0.1-0.1-0.1"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m10 11.2c0 0-0.1 0.1-0.1 0.2q0.1 0 0.1 0.1 0-0.1 0-0.1 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0.1 0 0.1 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0h-0.1 0.1l-0.1 0.1h0.1 0.1l-0.1-0.1h0.1-0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0.1-0.1 0 0 0 0 0 0 0.1 0-0.1-0.1-0.1-0.1 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0.1c0 0 0.1-0.1 0.1-0.2 0 0-0.1-0.1-0.1-0.1z"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m9.9 11.6h0.2-0.2z"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m9.9 11.6h0.2-0.2z"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m11.3 9.3q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c-0.1 0-0.1-0.1-0.1-0.1v0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0.1 0 0 0.1 0 0 0 0 0 0 0 0 0.1 0 0 0 0h0.1q0 0 0 0v-0.1c0 0 0 0.1 0 0q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.3 9.3q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c-0.1 0-0.1-0.1-0.1-0.1v0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0.1 0 0 0.1 0 0 0 0 0 0 0 0 0.1 0 0 0 0h0.1q0 0 0 0v-0.1c0 0 0 0.1 0 0q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m11.2 9.3q0 0 0 0"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.2 9.3q0 0 0 0z"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m11.3 9.4h-0.1 0.1q0 0 0 0z"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.3 9.4h-0.1 0.1q0 0 0 0z"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m11.2 9.3q0 0 0 0z"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.2 9.3q0 0 0 0z"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m11.1 9.3h0.1-0.1z"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.1 9.3h0.1-0.1z"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m11.3 9.4z"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.3 9.4z"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m11.3 9.4q0 0 0 0z"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.3 9.4q0 0 0 0z"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s21",
    d: "m11.4 9.5v-0.1h-0.1v0.1h0.1"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.4 9.5v-0.1h-0.1v0.1h0.1z"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m11.2 9.2v0.1l0.1-0.1z"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.2 9.2v0.1l0.1-0.1z"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m11.2 9.2v0.1-0.1z"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.2 9.2v0.1-0.1z"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m11.3 9.3h-0.1 0.1z"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.3 9.3h-0.1 0.1z"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m11.2 9.3q0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.2 9.3q0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0.1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1z"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m11.1 9.2q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.1 9.2q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m11.2 9.2h-0.1 0.1z"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.2 9.2h-0.1 0.1z"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m11.1 9.2q0 0 0 0 0 0 0 0 0 0 0 0"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.1 9.2q0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m11.3 9.3z"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.3 9.3z"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m11.3 9.3z"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.3 9.3z"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m11.3 9.3z"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.3 9.3z"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m11.3 9.3q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.3 9.3q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m11.4 9.3v0.1-0.1z"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.4 9.3v0.1-0.1z"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m11.4 9.4"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.4 9.4"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m11.3 9.3v0.1h0.1v-0.1z"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.3 9.3v0.1h0.1v-0.1z"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m11.4 9.4q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.4 9.4q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0z"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m11.4 9.5h0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0-0.1 0z"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.4 9.5h0.1q0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-0.1 0 0-0.1 0z"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m11.4 9.4v0.1-0.1"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.4 9.4v0.1-0.1"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m11.4 9.5q0.1 0 0-0.1 0 0.1 0 0.1"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m11.4 9.5q0.1 0 0-0.1 0 0.1 0 0.1zm1.6-1v-0.1h-0.1v0.1h0.1-0.1v0.1h0.1v-0.1z"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s24",
    d: "m7 9m0 0m0 0m0 0"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m7 9m-0.1 0m0 0m0 0m0 0m0 0m0 0m0 0m0 0m0 0m0 0m-0.1 0m0 0m0 0m0 0m0 0m0 0"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m6.8 9"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s24",
    d: "m7.1 9m-0.1 0m0 0m6 0m0 0m0 0m-0.1 0"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.9 9m0 0m0 0m0 0m0 0m0 0m0 0m0 0m0 0m-0.1 0m0 0m0 0m0 0m0 0m0 0m0 0m0 0"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s5",
    d: "m12.8 9"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s24",
    d: "m13 9m0 0m0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/es.f098d5756d5b96ae61284c17ba1b30e1.svg";
export { ForwardRef as ReactComponent };